import { useState, type ChangeEvent, type KeyboardEvent } from 'react'
import {
  Button,
  Card,
  IconButton,
  Stack,
  Text,
  TextField
} from '@backyard-ui/core'
import { MinusCircleOutline, PlusCircleOutline } from '@backyard-ui/icons'
import { useRange } from 'react-instantsearch'

interface QuantitySelectorProps {
  attribute: string
}

export function QuantitySelector(props: QuantitySelectorProps) {
  const { attribute } = props
  const { range, refine } = useRange({ attribute })
  const [value, setValue] = useState('1')

  const quantity = parseInt(value) || 1

  // Permite campo vazio (para redigitar) e apenas dígitos inteiros positivos
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const raw = event.target.value
    if (raw === '' || /^\d+$/.test(raw)) {
      setValue(raw)
    }
  }

  const handleApply = () => {
    refine([quantity, range.max])
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleApply()
    }
  }

  return (
    <Card.Root>
      <Card.Header>
        <Text weight="bold" size="md" asChild>
          <span>Disponibilidade, mínimo de peças:</span>
        </Text>
      </Card.Header>

      <Card.Body>
        <Stack align="center" spacing="2">
          <TextField.Root
            UNSAFE_style={{ width: '100%', justifyContent: 'space-between' }}>
            <TextField.Slot UNSAFE_style={{ paddingInline: '4px' }}>
              <IconButton
                size="sm"
                aria-label="Diminuir quantidade"
                icon={<MinusCircleOutline />}
                variant="ghost"
                isDisabled={quantity <= 1}
                onClick={() => setValue(String(quantity - 1))}
                UNSAFE_style={{
                  background: 'transparent',
                  border: 'none',
                  width: '28px',
                  height: '28px'
                }}
              />
            </TextField.Slot>

            <TextField.Input
              type="text"
              aria-label="Quantidade mínima de peças"
              value={value}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              UNSAFE_style={{ textAlign: 'center' }}
            />

            <TextField.Slot UNSAFE_style={{ paddingInline: '4px' }}>
              <IconButton
                size="sm"
                aria-label="Aumentar quantidade"
                icon={<PlusCircleOutline />}
                variant="ghost"
                onClick={() => setValue(String(quantity + 1))}
                UNSAFE_style={{ width: '28px', height: '28px' }}
              />
            </TextField.Slot>
          </TextField.Root>

          <Button size="sm" onClick={handleApply}>
            Aplicar
          </Button>
        </Stack>
      </Card.Body>
    </Card.Root>
  )
}
